import React, { useEffect, useRef } from "react";
import EnvironmentCard from "./EnvironmentCard/EnvironmentCard";
import { IEnvironment } from "store/environments/environment-types";
import { useTranslation } from "react-i18next";
import useRefreshPage from "hooks/useRefreshPage";
import ErrorSectionContainer from "../Common/ErrorSection/ErrorSectionContainer";
import "./Environments.less";
import { Heading } from "rsuite";

interface ComponentProps {
    environments: IEnvironment[];
    setActiveEnvironmentById: (id: string) => void;
    setActiveEnvironmentTenantsMonikers: () => void;
    fetchEnvironments: (EnvName?: string) => void;
    errorMessage: string;
}

const Environments: React.FC<ComponentProps> = ({
    environments,
    setActiveEnvironmentById,
    setActiveEnvironmentTenantsMonikers,
    fetchEnvironments,
    errorMessage,
}: ComponentProps) => {
    const { t } = useTranslation();
    const containerRef = useRef<HTMLDivElement>(null);

    const title = t("environment.layoutHeader");
    const environmentsGetter = () => {
        fetchEnvironments();
    };

    useEffect(environmentsGetter, [fetchEnvironments]);
    useRefreshPage(() => {
        containerRef.current?.scrollTo(0, 0);
        environmentsGetter();
    });

    if (errorMessage.length > 0) {
        return <ErrorSectionContainer />;
    }

    return (
        <>
            <Heading level={1} className="environments__header">
                {title}
            </Heading>

            <div ref={containerRef} className="cards-layout">
                {environments.map((env, index: number) => {
                    return (
                        <div
                            key={String(index)}
                            onClick={() => {
                                setActiveEnvironmentById(env.id);
                                setActiveEnvironmentTenantsMonikers();
                            }}
                        >
                            <EnvironmentCard environment={env} />
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default Environments;
